import { render, staticRenderFns } from "./SignatureList.vue?vue&type=template&id=2ae2f3a0&"
import script from "./SignatureList.vue?vue&type=script&lang=js&"
export * from "./SignatureList.vue?vue&type=script&lang=js&"
import style0 from "./SignatureList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports